import { NewVersionModal } from "@dwelldrop/shared";

export default function NewVersionBanner() {
  return <NewVersionModal currentVersion={import.meta.env.VITE_BUILD_ID} />;
}
